import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type InnerException = {
  targetSite: null;
  message: string;
  data: object;
  innerException: null;
  helpLink: null;
  source: null;
  hResult: number;
  stackTrace: null;
};

type ResponseType = {
  exception: null | InnerException;
  state: number;
  value: Schedule | null;
  isFaulted: boolean;
  isSuccess: boolean;
};

type GetBuqueResponse = ResponseType;

export interface Schedule {
  OidViaje: number;
  fullProcesadoCarga: number;
  fullProcesadoDescarga: number;
  total: number;
  totalCarga: number;
  totalCargaProcesada: number;
  totalDescarga: number;
  totalDescargaProcesada: number;
  totalFullCarga: number;
  totalFullDescarga: number;
  totalProcesado: number;
  totalTransitoCarga: number;
  totalTransitoDescarga: number;
  totalVacioCarga: number;
  totalVacioDescarga: number;
  transitoProcesadaCarga: number;
  transitoProcesadaDescarga: number;
  vacioProcesadoCarga: number;
  vacioProcesadoDescarga: number;
}

export interface GetBuque {
  codViaje: string;
}

export const getBuque = async ({ codViaje }: GetBuque): Promise<Schedule> => {
  try {
    const response = await apiClient.post<GetBuqueResponse>(
      Endpoints.AvanceBuque,
      {
        codViaje,
      }
    );
    if (response.data.isFaulted || !response.data.isSuccess) {
      throw new Error(
        response.data.exception?.message || 'An unknown error occurred'
      );
    }
    if (!response.data.value || !response.data.value) {
      throw new Error('No data returned from the server');
    }
    return response.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.response?.data.message || error.message);
    }
    throw error;
  }
};
